import { createContext } from "react";

import type { Finding } from "../model/Finding";

// Находка, которую рисует карточка: `FindingView` кладёт её сюда, `FindingCard` по ней
// дорисовывает советы «как исправить» — компонентам кодов передавать их не нужно.
export const FindingContext = createContext<Finding | null>(null);
